import { CaretDownFilled, FilterOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  Row,
  Select,
  Space,
  Switch,
  Cascader as Cascaded,
  Dropdown,
  Menu,
  Checkbox,
} from 'antd'
import moment from 'moment'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from '../../compnents/form/DateSelect'
import styles from './prescriptionManagement.module.css'
import { FilterColumn } from '../../compnents/filterForm/filterForm'
import { getChainListAsync } from '../warehouseStatement/allReport/warehouseChangeReport/warehouseChangeReportSlice'
import { selectRole } from '../../app/applicationSlice'
import { RecipeStateList, getRecipeState } from '../../models/prescriptionManagement'

export const Query = (props: {
  loading?: any
  filterColumn?: any
  filterSelectList?: any
  alertMessage: () => void
  submitPageList?: (selectedColumns: string[]) => void
  onValueChange: (params: any) => void
  settingVoid?: () => void
  allowPrintUndecoction?: boolean
  onAllowPrintUndecoctionChange?: (checked: boolean) => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const role = useSelector(selectRole)

  const [organizationData, setOrganizationData] = useState<any>([])

  const [current, setCurrent] = useState<any>()

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_chufangguanli') || '{}'
  )

  useEffect(() => {
    const [head, tail] = getDateRange(DateRangeType.Today)

    if (
      Object.keys(storageParams).length
    ) {
      form.setFieldsValue({
        ...storageParams,
        tenantIds: storageParams?.tenantIds ? storageParams?.tenantIds?.split(',') : []  ,
        timeHead: storageParams?.timeHead || head,
        timeTail: storageParams?.timeTail || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
      })
    } else {
      form.setFieldsValue({
        _dateRange: 0,
        registrationTimeHead: head,
        registrationTimeTail: tail,
      })
    }
    form.submit()
  }, [])

  const refresh = () => {
    props.onValueChange({
      ...storageParams,
      ...form.getFieldsValue(),
      current: current || 1,
      tenantIds: form.getFieldsValue()?.tenantIds?.join(','),
    })
  }

  useEffect(() => {
    dispatch(getChainListAsync())
      .then(unwrapResult)
      .then((res: any) => {
        setOrganizationData(res)
      })
  }, [])

  return (
    <Form
      className={styles.formStyle}
      form={form}
      onFinish={(values) => {
        const data = storageParams
        props.onValueChange({
          ...data,
          ...values,
          tenantIds: values?.tenantIds?.join(','),
          current: current,
        })
      }}
    >
      <Row style={{ marginTop: 10, marginBottom: 10 }} justify='space-between'>
        <Space wrap>
          <Form.Item noStyle name='params'>
            <Input
              autoComplete='off'
              maxLength={20}
              prefix={<SearchOutlined />}
              placeholder='患者姓名/手机号'
              style={{ width: '14rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            />
          </Form.Item>
          <Form.Item name='tenantIds' noStyle>
            <Select
              placeholder='机构名称'
              allowClear
              mode='multiple'
              dropdownClassName={styles.selectDropdown}
              style={{ minWidth: 150, maxWidth: 410 }}
              onChange={() => {
                refresh()
              }}
            >
              {/* <Select.Option key={' '} value={' '}>
                  全部
                </Select.Option> */}
              {organizationData?.map((v: any) => {
                return (
                  <Select.Option value={v?.id?.toString()} key={v?.id}>
                    {v?.name}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='settleState' noStyle>
            <Select
              placeholder='结算状态'
              style={{ width: '9rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            >
              {RecipeStateList.map((v: any) => {
                return (
                  <Select.Option key={v} value={v}>
                    {getRecipeState(v)}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <DateSelect
            allowClear={false}
            style={{ width: '7rem' }}
            labelPrefix=''
            namePrefix='time'
            options={TJFXTime}
            placeholder='收费时间'
            initialValue={DateRangeType.Today}
            onChange={(e) => {
              if (e != 6) {
                refresh()
              }
            }}
          />
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              setCurrent(1)
              refresh()
            }}
          >
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
        </Space>
        <Space>
          <span>未代煎允许打印：</span>
          <Switch
            checkedChildren='开启'
            unCheckedChildren='关闭'
            checked={props.allowPrintUndecoction}
            onChange={(v) => {
              props.onAllowPrintUndecoctionChange && props.onAllowPrintUndecoctionChange(v)
            }}
          />
        </Space>
      </Row>
    </Form>
  )
}
